<template>
  <div class="q-ml-md">
    <div class="q-mb-md text-brand-1 text-weight-bold" style="font-size: 16px">
      Retirada nos Tablets por ID (Crachá)
    </div>
    <q-form ref="myForm" @submit.prevent="criarPin" class="q-ml-sm">
      <div class="row col-12 q-gutter-sm text-brand-1 text-weight-bold">
        <div class="col-2">
          <div class="q-ml-sm">ID</div>
          <q-input
            :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            v-model="objetoCriarPin.idCracha"
            dense
            outlined
          />
        </div>
        <div class="col-2">
          <div class="q-ml-sm">Senha</div>
          <q-input
            v-model="objetoCriarPin.senha"
            :type="isPwd ? 'password' : 'text'"
            dense
            lazy-rules
            :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            outlined
          >
            <template v-slot:append>
              <q-icon
                :name="isPwd ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwd = !isPwd"
              />
            </template>
          </q-input>
        </div>
        <div class="col-2">
          <div class="q-ml-sm">Confirmar Senha</div>
          <q-input
            :type="isPwdConfirmacao ? 'password' : 'text'"
            dense
            outlined
            lazy-rules
            :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            v-model="objetoCriarPin.confirmacaoSenha"
          >
            <template v-slot:append>
              <q-icon
                :name="isPwdConfirmacao ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwdConfirmacao = !isPwdConfirmacao"
              />
            </template>
          </q-input>
        </div>
      </div>
      <div class="row col-12 q-mt-md q-gutter-sm">
        <q-btn
          label="Salvar Pin"
          style="background-color: #21324a; border-radius: 8px; color: white"
          no-caps
          icon="save"
          :disable="disable"
          type="submit"
        />
      </div>
    </q-form>

    <div v-if="pins.length > 0" class="row col-12 q-mt-xl q-ml-sm">
      <div
        class="row col-12 q-mb-md text-brand-1 text-weight-bold"
        style="font-size: 16px"
      >
        ID(s) Cadastrado(s)
      </div>
      <div class="row col-12 q-col-gutter-sm">
        <div v-for="(pin, index) in pins" :key="index" class="row col-12">
          <div
            class="col-6 q-pa-md"
            style="border: 1px solid #d9d9d9; border-radius: 8px"
          >
            <div class="row col-12 justify-between">
              <span class="text-weight-medium"> {{ pin.card_id }} </span>
              <span style="color: #8a8a8a" v-if="pin.expandir">
                Editando...
              </span>
            </div>

            <div
              v-if="pin.expandir"
              class="row col-12 q-mt-md q-gutter-sm text-weight-bold text-brand-1"
            >
              <div class="col">
                <div class="q-ml-sm">Senha</div>
                <q-input
                  v-model="pin.senha"
                  :type="pin.isPwd ? 'password' : 'text'"
                  dense
                  :rules="[
                    (val) => (val && val.length > 0) || 'Campo Obrigatório',
                  ]"
                  outlined
                >
                  <template v-slot:append>
                    <q-icon
                      :name="pin.isPwd ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="pin.isPwd = !pin.isPwd"
                    />
                  </template>
                </q-input>
              </div>
              <div class="col">
                <div class="q-ml-sm">Confirmar Senha</div>
                <q-input
                  v-model="pin.confirmacaoSenha"
                  :type="pin.isPwdConfirmacao ? 'password' : 'text'"
                  dense
                  :rules="[
                    (val) => (val && val.length > 0) || 'Campo Obrigatório',
                  ]"
                  outlined
                >
                  <template v-slot:append>
                    <q-icon
                      :name="
                        pin.isPwdConfirmacao ? 'visibility_off' : 'visibility'
                      "
                      class="cursor-pointer"
                      @click="pin.isPwdConfirmacao = !pin.isPwdConfirmacao"
                    />
                  </template>
                </q-input>
              </div>
            </div>
          </div>
          <div>
            <div v-if="!pin.expandir">
              <q-icon
                size="18px"
                name="sym_o_edit"
                class="q-mx-sm icon"
                :disable="disable"
                style="color: #3d71b8"
                @click="pin.expandir = !pin.expandir"
              />
              <q-icon
                size="18px"
                color="red"
                :disable="disable"
                name="sym_o_delete"
                class="icon"
                @click="excluirPin(pin)"
              />
            </div>
            <div v-else>
              <q-icon
                size="18px"
                name="sym_o_done_outline"
                class="q-mx-sm icon"
                :disable="disable"
                style="color: #5b9ed6"
                @click="editarPin(pin, index)"
              />
              <q-icon
                size="18px"
                name="sym_o_close"
                class="icon"
                :disable="disable"
                color="red"
                @click="
                  (pin.expandir = !pin.expandir),
                    (pin.senha = ''),
                    (pin.confirmacaoSenha = '')
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const route = useRoute();
const store = useStore();
const quasar = useQuasar();

const pins = ref([]);
const myForm = ref(null);
const isPwd = ref(true);
const isPwdConfirmacao = ref(true);
const objetoCriarPin = ref({
  idCracha: "",
  senha: "",
  confirmacaoSenha: "",
});
const disable = ref(false);

const detalharPinUsuario = async () => {
  disable.value = true;
  try {
    const response = await store.dispatch("usuarioNovo/detalharFuncionario", {
      id: route.params.id,
    });

    disable.value = false;

    pins.value = response.data.model.pins.map((pin) => {
      pin.isPwd = true;
      pin.isPwdConfirmacao = true;
      pin.expandir = false;
      return pin;
    });
  } catch (error) {
    console.log(error);
    disable.value = false;
  }
};

const criarPin = async () => {
  if (objetoCriarPin.value.senha !== objetoCriarPin.value.confirmacaoSenha) {
    quasar.notify({
      message: "As senhas não coincidem.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  try {
    await store.dispatch("usuarioNovo/cadastrarPinFuncionario", {
      funcionario_id: parseInt(route.params.id),
      senha: objetoCriarPin.value.senha,
      cartao_id: objetoCriarPin.value.idCracha,
    });
    quasar.notify({
      message: "Crachá criado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    detalharPinUsuario();
    reset();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao criar crachá.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const editarPin = async (pin, index) => {
  if (
    (pin.senha == "" && pin.confirmacaoSenha == "") ||
    (pin.senha == undefined && pin.confirmacaoSenha == undefined)
  ) {
    pins.value[index].expandir = false;
    return;
  }
  if (
    pin.senha == "" ||
    pin.confirmacaoSenha == "" ||
    pin.senha == undefined ||
    pin.confirmacaoSenha == undefined
  ) {
    quasar.notify({
      message: "Preencha todos os campos.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (pin.senha !== pin.confirmacaoSenha) {
    quasar.notify({
      message: "As senhas não coincidem.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  try {
    await store.dispatch("usuarioNovo/editarPinFuncionario", {
      id: pin.id,
      user_id: parseInt(route.params.id),
      password: objetoCriarPin.value.senha,
      card_id: objetoCriarPin.value.idCracha,
    });
    quasar.notify({
      message: "Crachá editado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    detalharPinUsuario();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao editar crachá.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const excluirPin = async (pin) => {
  try {
    await store.dispatch("usuarioNovo/excluirPinFuncionario", {
      id: pin.id,
    });
    quasar.notify({
      message: "Crachá excluído com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    detalharPinUsuario();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao excluír crachá.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const reset = () => {
  objetoCriarPin.value = {
    idCracha: null,
    senha: null,
    confirmacaoSenha: null,
  };
  myForm.value.resetValidation();
};

onMounted(() => {
  detalharPinUsuario();
});
</script>

<style scoped>
.icon {
  cursor: pointer;
}
</style>
